import { addLogLine } from './log';
import Mdn from '../shared/mdn';

export type UserSessionParams = {
    userId: string,
    siteId: string,
    extVersion: string,
    mdnObj: Mdn,
    priceString?: string
}

type NormalizedUserSessionParams = {
    userId: string,
    siteId: string,
    extVersion: string,
    mdnObj: Mdn,
    priceString: string
}
export function normalizeUserSessionParams(userSessionParams: UserSessionParams): NormalizedUserSessionParams | undefined {
    let userId = userSessionParams.userId;
    if (!userId) {
        addLogLine('Could not extract userId - got ' + userId);
        return;
    }
    let siteId = userSessionParams.siteId;
    if (!siteId) {
        addLogLine('Could not extract siteId - got ' + siteId);
        return;
    }
    let extVersion = userSessionParams.extVersion;
    if (!extVersion) {
        addLogLine('Could not extract extVersion - got ' + extVersion);
        return;
    }
    let mdnObj = userSessionParams.mdnObj;
    if (!mdnObj) {
        addLogLine('Invalid mdnObj - got ' + mdnObj);
        return;
    }
    addLogLine('Got valid MDN: ' + mdnObj);
    let priceString = userSessionParams.priceString;
    if (!priceString) {
        addLogLine('Could not extract Price - got ' + priceString + ' - setting to empty string');
        priceString = '';
    }
    return {
        userId,
        siteId,
        extVersion,
        mdnObj,
        priceString,
    };
}